import { useEffect, useState } from 'react';
import { fetchThumbnailObjectUrl } from '../lib/api';
import { fileKind } from '../lib/format';
import type { FileItem } from '../lib/types';

const ICONS: Record<string, string> = {
  image: '🖼️',
  video: '🎬',
  audio: '🎵',
  archive: '🗜️',
  pdf: '📄',
  other: '📦',
};

export function Thumbnail({ file }: { file: FileItem }) {
  const [url, setUrl] = useState<string | null>(null);
  const kind = fileKind(file.mime_type);
  const eligible = file.has_thumbnail && (kind === 'image' || kind === 'video');

  useEffect(() => {
    if (!eligible) return;
    let active = true;
    let created: string | null = null;
    fetchThumbnailObjectUrl(file.id).then((u) => {
      if (active && u) {
        created = u;
        setUrl(u);
      }
    });
    return () => {
      active = false;
      if (created) URL.revokeObjectURL(created);
    };
  }, [file.id, eligible]);

  if (url) return <img src={url} alt="" className="h-10 w-10 shrink-0 rounded object-cover" />;
  return (
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded bg-slate-100 text-lg">
      {ICONS[kind] ?? ICONS.other}
    </div>
  );
}
